export default __webpack_public_path__ + "static/media/HDTX_Form Daftar Buyback_Scripless 2025.8d2853ec.pdf";